// Klaviyo "Added to Cart" tracking.
// Restored from commit 60ab1ee (2023-08) — accidentally removed in 01a9bc6
// (2026-02) while fixing BIS buttons. Kept as a dedicated file so it is not
// pulled out again during unrelated edits to theme.liquid.
//
// Hooks window.fetch so every AJAX /cart/add path (product-form.js,
// bundle-manager.js, additional-cart-items.js, cart-drawer.js) triggers one
// track call with the full cart snapshot — matches the historical payload
// shape expected by the existing Klaviyo flow.
(function () {
  if (window.__heidemanKlaviyoAtcHooked) return;
  window.__heidemanKlaviyoAtcHooked = true;

  function trackAddedToCart() {
    fetch(window.location.origin + '/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var payload = {
          total_price: data.total_price / 100,
          $value: data.total_price / 100,
          total_discount: data.total_discount,
          original_total_price: data.original_total_price / 100,
          items: data.items,
        };
        var klaviyo = (window.klaviyo = window.klaviyo || []);
        klaviyo.push(['track', 'Added to Cart', payload]);
      })
      .catch(function () {});
  }

  var originalFetch = window.fetch;
  window.fetch = function () {
    var response = originalFetch.apply(this, arguments);
    Promise.resolve(response)
      .then(function (res) {
        if (!res || !res.url || !res.ok) return;
        if (/\/cart\/add(\.js)?(\?|$)/.test(res.url)) {
          trackAddedToCart();
        }
      })
      .catch(function () {});
    return response;
  };
})();
